import { memo, forwardRef, useImperativeHandle } from 'react';
import { generateOssParams, uploadFile } from '@/sub-luca-plugin/utils';
import { loadImg } from '@/sub-luca-plugin/utils/tools';
import { ICombineCompressUploadRef } from '@/sub-luca-plugin/types/models/compatible-components';

interface IProps {
    canvasId?: string;
}

const CombineCompressUpload = forwardRef<ICombineCompressUploadRef, IProps>((_, ref) => {
    // 获取图片的绘制信息
    const getDrawInfo = async (urls: string[]) => {
        type TDrawInfo = {
            canvasWidth: number;
            canvasHeight: number;
            drawImageParamsList: Array<[HTMLImageElement, number, number, number, number]>;
        };
        const drawInfo: TDrawInfo = { canvasWidth: 0, canvasHeight: 0, drawImageParamsList: [] };
        const imgs = await Promise.all(urls.map(url => loadImg(url)));
        return imgs.reduce((info, img) => {
            info.drawImageParamsList.push([img, 0, info.canvasHeight, img.width, img.height]);
            info.canvasWidth = Math.max(info.canvasWidth, img.width);
            info.canvasHeight += img.height;
            return info;
        }, drawInfo);
    };

    // 合并压缩图片并上传
    const getCombinePictureUrl = (urls: string[]): Promise<string> =>
        new Promise(async resolve => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d')!;
            const { canvasWidth, canvasHeight, drawImageParamsList } = await getDrawInfo(urls);
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            drawImageParamsList?.forEach(params => ctx.drawImage(...params));
            canvas.toBlob(
                async blob => {
                    if (!blob) return;
                    const file = new File([blob], 'image.png', { type: 'image/png', lastModified: Date.now() });
                    // console.log(`合成图大小：${Math.round((file.size / 1024 / 1024) * 10) / 10}M；`);
                    const url = await uploadFile(file);
                    resolve(`${url}${generateOssParams(canvasWidth, canvasHeight)}`);
                },
                'image/jpg',
                0.7
            );
        });

    useImperativeHandle(
        ref,
        () => {
            return {
                getCombinePictureUrl,
            };
        },
        []
    );

    return null;
});

CombineCompressUpload.displayName = 'CombineCompressUpload';

export default memo(CombineCompressUpload);
